import { useEffect } from "react";

// Use `any` for the `cloudinary` property in the global `Window` interface to avoid type conflicts
declare global {
  interface Window {
    cloudinary?: any; // Loose type to prevent conflicts
  }
}

export type UploadWidgetProps = {
  folder: string;
  styles?: Object;
  multiple: boolean;
};

export const openUploadWidget = (
  props: UploadWidgetProps
): Promise<string[]> => {
  return new Promise((resolve, reject) => {
    if (window && window.cloudinary) {
      const results: Array<string> = [];
      const widget = window.cloudinary.createUploadWidget(
        {
          cloudName: "dbm1qiew0",
          uploadPreset: "vxcyvgez",
          sources: ["local"],
          resourceType: "image",
          folder: props.folder,
          maxImageWidth: 1080,
          showAdvancedOptions: false,
          cropping: false,
          multiple: props.multiple,
          maxFiles: 5,
          defaultSource: "local",
          styles: props.styles,
        },
        (error: any, result: any) => {
          if (error) {
            console.error("Upload Widget Error:", error);
            reject(error);
          } else if (result && result.info && result.event === "success") {
            results.push(result.info.secure_url);
          } else if (result && result.event === "close") {
            resolve(results);
          }
        }
      );
      widget.open();
    } else {
      reject(new Error("Cloudinary widget is not available"));
    }
  });
};

export const useCloudinaryWidget = () => {
  useEffect(() => {
    if (
      !document.querySelector(
        "script[src='https://upload-widget.cloudinary.com/global/all.js']"
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://upload-widget.cloudinary.com/global/all.js";
      script.async = true;
      script.onload = () => console.log("Script loaded successfully.");
      script.onerror = () => console.error("Script failed to load.");
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
    return;
  }, []);
};
